import styled from '@emotion/styled'
import { Button } from '@mui/material'

export const ProgramContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  margin-bottom: 20px;
  background: #202327;
  color: white;
`

export const ProgramHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;

  h2 {
    margin: 0;
  }

  @media screen and (max-width: 990px) {
    align-items: flex-start;
    flex-direction: column;
  }
`

export const DurationContainer = styled.div`
  display: flex;
  gap: 8px;
`

export const DurationButton = styled(Button)<{ selected?: boolean }>`
  color: white !important;
  background: ${({ selected }) =>
    selected ? '#ff8e00' : '#353c4b'} !important;
`

export const ProgramSteps = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;

  @media screen and (max-width: 990px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`

export const ProgramStep = styled.div<{ disabled?: boolean }>`
  padding: 14px;
  background: ${({ disabled }) => (disabled ? '#24262a' : '#353c4b')};
  color: ${({ disabled }) => (disabled ? '#717782' : '#fff')};
  opacity: ${({ disabled }) => (disabled ? 0.65 : 1)};

  strong {
    display: block;
    margin-bottom: 6px;
    color: ${({ disabled }) => (disabled ? '#717782' : '#ff8e00')};
  }

  h3 {
    margin: 0 0 5px;
    font-size: 16px;
  }

  p {
    margin: 0;
    font-size: 13px;
  }
`
